import axiosWrapper from "common/axiosWrapper";

/**
 * Links the signed-in account to the provider the code came from.
 *
 * @param {string} provider "discord", "google" or "reddit".
 * @param {string} code The provider's access code.
 */
export const linkAccount = async (provider, code) => {
	return await axiosWrapper.get(`api/auth/link-${provider}?code=${code}`);
};
